<!-- 登录页面 -->
<template>
  <div class="login">
    <div class="login-cell">
      <div class="loginMsg">
        <h3>用户登录</h3>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          size="small"
        >
          <el-form-item prop="username">
            <el-input
              prefix-icon="el-icon-user"
              type="text"
              placeholder="请输入用户名"
              v-model="ruleForm.username"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              prefix-icon="el-icon-lock"
              type="password"
              placeholder="请输入密码"
              v-model="ruleForm.password"
            ></el-input>
          </el-form-item>
          <el-form-item prop="captcha" class="login-captcha">
            <el-input
              prefix-icon="el-icon-timer"
              type="text"
              placeholder="请输入图片验证码"
              v-model="ruleForm.captcha"
            ></el-input>
            <div class="capImg">
              <img :src="img" @click="getNewCodeImgKey()" alt="验证码" />
            </div>
          </el-form-item>
          <el-form-item class="submitbtn">
            <el-button
              type="primary"
              @click.enter="submitForm('ruleForm')"
              @keyup.enter.native="loginEnter"
            >{{ loginText }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { Form, FormItem, Input, Button } from 'element-ui'
import {
  setCookie
} from '../../util/utils'
export default {
  data () {
    return {
      loginText: '登录',
      ruleForm: {
        username: '',
        password: '',
        captcha: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ]
      },
      // uuid
      randomKey: this.getNewCodeImgKey(),
      // 验证码图片存储参数
      img: this.commonapi + '/captcha?uuid=' + this.randomKey
    }
  },
  components: {
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-button': Button
  },
  created () {
    this.getNewCodeImgKey()
    document.onkeydown = (e) => {
      if (window.event === undefined) {
        var key = e.keyCode
      } else {
        // eslint-disable-next-line no-redeclare
        var key = window.event.keyCode
      }
      if (key === 13) {
        this.loginEnter()
      }
    }
  },
  mounted () { },
  methods: {
    // 登录
    submitForm (rulename) {
      this.$refs[rulename].validate((valid) => {
        if (valid) {
          this.$http({
            method: 'post',
            url: '/sys/login',
            params: {
              username: this.ruleForm.username,
              password: this.ruleForm.password,
              captcha: this.ruleForm.captcha,
              uuid: this.randomKey
            }
          }).then(res => {
            if (res.code === 100) {
              this.loginText = '登录中...'
              setCookie('pd_token', res.token) // 存储token值，存入cookie
              this.getUserinfo(() => { // 请求用户信息。存入缓存，成功存入后，跳转首页
                this.loginText = '登录'
                this.$router.push({
                  path: '/'
                })
              })
            } else {
              this.$message.error(res.msg)
              this.getNewCodeImgKey()
            }
          }).catch(error => {
            this.getNewCodeImgKey()
            console.log(error)
            return false
          })
        } else {
          //console.log('error submit!!')
          return false
        }
      })
    },
    resetForm (ruleForm) {
      this.$refs[ruleForm].resetFields()
    },
    getNewCodeImgKey () {
      // this.randomKey = Math.ceil(Math.random() * 1000) // 生成一个随机key（防止缓存)
      this.randomKey = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = Math.random() * 16 | 0
        let v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
      this.img = this.commonapi + '/captcha?uuid=' + this.randomKey
    },
    loginEnter () {
      this.submitForm('ruleForm')
    }
  }
}
</script>
<style lang="scss">
.login {
  width: 100%;
  min-height: 100%;
  min-width: 1200px;
  background-image: url("../../assets/image/loginbg-wrap.jpg");
  overflow: auto;
  position: fixed;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-cell {
  width: 70%;
  height: 75vh;
  margin: auto;
  background-image: url("../../assets/image/loginbg-inner.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 5px;
  box-shadow: 0px 0px 20px -5px rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.loginMsg {
  width: 300px;
  padding-right: 160px;
  .login-captcha {
    .el-input {
      input {
        box-sizing: border-box;
        padding-right: 140px;
        overflow: hidden;
      }
    }
  }
}
.capImg {
  position: absolute;
  top: 3px;
  right: 3px;
  width: 98px;
  height: 34px;
  z-index: 5;
  box-sizing: border-box;
  background-color: #f2f2f2;
  img {
    width: 100%;
    height: 100%;
  }
}
.loginMsg {
  .el-form-item {
    input {
      border-radius: 0;
    }
  }
  .submitbtn {
    text-align: center;
  }

  .el-form-item__label::before {
    display: none;
  }

  .el-form-item--small .el-form-item__content {
    margin-left: 0 !important;
  }

  .el-input--small .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  .el-input--small .el-input__icon {
    line-height: 40px;
    font-size: 16px;
  }

  h3 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 50px;
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 25px;
  }

  .el-button--small {
    padding: 11px 14px;
    border-radius: 0;
    -webkit-border-radius: 0;
    -moz-border-radius: 0;
    -ms-border-radius: 0;
    -o-border-radius: 0;
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue